import React from 'react'
import { useAppInfo } from '@ztechapps/common.hook'

export type AppVersionProps = {
  versionNumber?: string
  className?: string
}

export const AppVersion = ({ versionNumber, className = 'small' }: AppVersionProps) => {
  const { version, loading } = useAppInfo()

  versionNumber = versionNumber ?? version ?? '0.0.0'
  return (
    <div className={className}>
      v<strong>{loading ? '---' : versionNumber}</strong>
    </div>
  )
}
